import { render } from "./card-product-mapping.vue?vue&type=template&id=3d47e6ee"
import script from "./card-product-mapping.vue?vue&type=script&lang=js"
export * from "./card-product-mapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__